// Bootstrap the application
import "./_Bootstrap/Bootstrap";
import { createRoot } from "react-dom/client";
import GlobalLogin from "./GlobalLogin";

// Render the application
createRoot(document.getElementById("root") as HTMLElement).render(<GlobalLogin />);
